import { AppThunk } from '../../../store/rootReducer';
import { DelineationId } from '../types/delineation.type';
import { loadDelineationWaves } from './load-delineation-waves.thunk';
import { selectDelineation } from './select-delineation.thunk';

export const pickDelineation =
  (delineationId: DelineationId, initialLoad = false): AppThunk =>
  async (dispatch) => {
    dispatch(selectDelineation(delineationId, { history: !initialLoad }));
    await dispatch(loadDelineationWaves(delineationId));
  };
